<template>
  <app-layout></app-layout>
</template>

<script>
import AppLayout from "./components/appLayout.vue";
import tr from "./config/tr.json"; // If language switch needed, this can be used.
import en from "./config/en.json"; // If language switch needed, this can be used.

export default {
  name: "App",
  components: {
    AppLayout,     
  },
  data() {
    return {
      TR: tr,
      EN: en
    };
  },
  
};
</script>

